import { TestData } from '../types';
import { ImageUrl } from '../constants/image-urls';

export const renderCovidTestListItem = (testsList: TestData[]) => {
  return (
    <>
      {testsList.map((test, index) => (
        <div key={index} role="listitem" className={`tests-collection-item w-dyn-item ${index === 0 && 'mt-4'}`}>
          <a data-w-id="57f11da3-7d0f-4acd-7116-8188e32906ab" href={`/test/${test.slug}`}
             className={`test-link w-full ${index % 2 === 0 ? 'bg-transparent' : 'bg-gray'}`}>
            <div className={`row-background row-background_smarch ${index % 2 === 0 ? 'bg-white' : 'bg-gray'}`}>
              <div
                className={`w-full table-row-grid covid ${test.mobileLabCovidTest ? 'mobile' : 'covid-test'} ${test.genicaCovidTest ? 'covid-test' : ''} ${test.airportCovidTest ? 'airport' : ''} `}>
                <div id="w-node-f794a596-fa9c-bbe9-67bf-e09f3772376e-634ceff9"
                     className="table-row-content table-row-content_smarch">
                  <div className="text-block-13 text-left">{test.name}</div>
                </div>
                
                {!test.genicaCovidTest && !test.airportCovidTest && !test.covidTestType && (
                  <>
                    {/*<div id="w-node-f794a596-fa9c-bbe9-67bf-e09f37723771-634ceff9"*/}
                    {/*     className="table-row-content table-row-content_smarch">*/}
                    {/*  <div>{test.duration || ''}</div>*/}
                    {/*</div>*/}
                    {/*<div id="w-node-f794a596-fa9c-bbe9-67bf-e09f37723774-634ceff9" className="table-row-content table-row-content_smarch">*/}
                    {/*  <div className="text-block-23">24/7</div>*/}
                    {/*</div>*/}
                    {/*<div id="w-node-f794a596-fa9c-bbe9-67bf-e09f37723777-634ceff9" className="table-row-content table-row-content_smarch">*/}
                    {/*  <div>03:00 - 18:00</div>*/}
                    {/*</div>*/}
                    {/*<div id="w-node-f794a596-fa9c-bbe9-67bf-e09f3772377a-634ceff9"*/}
                    {/*     className="table-row-content table-row-content_smarch">*/}
                    {/*  <div className="text-block-24">{test.sample}</div>*/}
                    {/*</div>*/}
                  </>
                )}
                
                {test.airportCovidTest && (
                  <>
                    {/*<div id="w-node-f794a596-fa9c-bbe9-67bf-e09f37723771-634ceff9"*/}
                    {/*     className="table-row-content table-row-content_smarch">*/}
                    {/*  <div>{test.duration || ''}</div>*/}
                    {/*</div>*/}
                    {/*<div id="w-node-f794a596-fa9c-bbe9-67bf-e09f37723774-634ceff9"*/}
                    {/*     className="table-row-content table-row-content_smarch">*/}
                    {/*  <div className="text-block-23">24/7</div>*/}
                    {/*</div>*/}
                    {/*<div id="w-node-f794a596-fa9c-bbe9-67bf-e09f37723777-634ceff9"*/}
                    {/*     className="table-row-content table-row-content_smarch">*/}
                    {/*  <div> {is247Test(test.id) ? testId247Text : '03:00 - 18:00'}</div>*/}
                    {/*</div>*/}
                    {/*<div id="w-node-f794a596-fa9c-bbe9-67bf-e09f3772377a-634ceff9"*/}
                    {/*     className="table-row-content table-row-content_smarch">*/}
                    {/*  <div className="text-block-24">{test.sample}</div>*/}
                    {/*</div>*/}
                  </>
                )}
                
                {test.genicaCovidTest && (
                  <>
                    {/*<div id="w-node-f794a596-fa9c-bbe9-67bf-e09f37723771-634ceff9"*/}
                    {/*     className="table-row-content table-row-content_smarch">*/}
                    {/*  <div>{test.duration || ''}</div>*/}
                    {/*</div>*/}
                    {/*<div id="w-node-f794a596-fa9c-bbe9-67bf-e09f37723774-634ceff9" className="table-row-content table-row-content_smarch">*/}
                    {/*  <div className="text-block-23">24/7</div>*/}
                    {/*</div>*/}
                    {/*<div id="w-node-f794a596-fa9c-bbe9-67bf-e09f37723777-634ceff9" className="table-row-content table-row-content_smarch">*/}
                    {/*  <div>03:00 - 18:00</div>*/}
                    {/*</div>*/}
                    {/*<div id="w-node-f794a596-fa9c-bbe9-67bf-e09f3772377a-634ceff9"*/}
                    {/*     className="table-row-content table-row-content_smarch">*/}
                    {/*  <div className="text-block-24">{test.sample}</div>*/}
                    {/*</div>*/}
                  </>
                )}
                
                {test.mobileLabCovidTest && (
                  <>
                    {/*<div id="w-node-f794a596-fa9c-bbe9-67bf-e09f37723771-634ceff9"*/}
                    {/*     className="table-row-content table-row-content_smarch">*/}
                    {/*  <div>{test.duration || ''}</div>*/}
                    {/*</div>*/}
                    {/*<div id="w-node-f794a596-fa9c-bbe9-67bf-e09f37723774-634ceff9" className="table-row-content table-row-content_smarch">*/}
                    {/*  <div className="text-block-23">24/7</div>*/}
                    {/*</div>*/}
                    {/*<div id="w-node-f794a596-fa9c-bbe9-67bf-e09f37723777-634ceff9" className="table-row-content table-row-content_smarch">*/}
                    {/*  <div>03:00 - 18:00</div>*/}
                    {/*</div>*/}
                    {/*<div id="w-node-f794a596-fa9c-bbe9-67bf-e09f3772377a-634ceff9"*/}
                    {/*     className="table-row-content table-row-content_smarch">*/}
                    {/*  <div className="text-block-24">{test.sample}</div>*/}
                    {/*</div>*/}
                  </>
                )}
                
                <div id="w-node-f794a596-fa9c-bbe9-67bf-e09f3772377d-634ceff9"
                     className="table-row-content price">
                  <div className="text-block-7">{test.price} лв</div>
                  <div className="info-icon">
                    <img
                      // style="display:block;opacity:1"
                      loading="lazy"
                      src={ImageUrl.INFO_ICON} alt=""
                      className="normal"/>
                    <img
                      // style="opacity:0;display:none"
                      loading="lazy"
                      src={ImageUrl.INFO_ICON_HOVER} alt=""
                      className="hover"/>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      ))}
    </>
  );
};

export const renderCovidTestListItemMobile = (testsList: TestData[]) => {
  
  return (
    <>
      {testsList.map((test, index) => (
        test.genicaCovidTest && (
          <div key={index} role="listitem" className="w-dyn-item">
            <a href={`/test/${test.slug}`} data-w-id="8aa3ccc3-c813-add4-0fca-9cbc322f5e5b"
               className="test-link-card price w-block">
              <div className="test-card-content-top">
                <h3 className="title test-title text-left">{test.name}</h3>
                <div className="info-icon covid">
                  <img
                    style={{ display: 'block', opacity: 1 }}
                    loading="lazy"
                    src={ImageUrl.INFO_ICON} alt=""
                    className="normal"/>
                  <img
                    style={{ opacity: 0, display: 'none' }}
                    loading="lazy" src={ImageUrl.INFO_ICON_HOVER}
                    alt=""
                    className="hover"/>
                </div>
              </div>
              
              <div className="card-career-about">
                {/*{test.duration && (*/}
                {/*  <div className="test-card-tag tag-margin">*/}
                {/*    <div className="card-image-box">*/}
                {/*      <img src={ImageUrl.CLOCK_ICON} alt=""*/}
                {/*           className="image"/>*/}
                {/*    </div>*/}
                {/*    <div>{test.duration}</div>*/}
                {/*  </div>*/}
                {/*)}*/}
                
                {test.price && (
                  <div className="test-price-tag tag-margin">
                    <div className="card-image-box">
                      <img width="16" src={ImageUrl.PRICE_ICON}
                           alt=""
                           className="image"/>
                    </div>
                    <div className="price-number">   {(test.price?.length || test.price) && (
                      <span>{test.price?.replace('лева', '').trim()} лв.</span>
                    )}</div>
                  </div>
                )}
                
                {/*{test.sample && (*/}
                {/*  <div className="test-sample-tag">*/}
                {/*    <div className="card-image-box">*/}
                {/*      <img width="16"*/}
                {/*           src={ImageUrl.SAMPLE_ICON_EMPTY} alt=""*/}
                {/*           className="image"/>*/}
                {/*    </div>*/}
                {/*    <div className="price-number">{test.sample}</div>*/}
                {/*  </div>*/}
                {/*)}*/}
              </div>
            </a>
          </div>
        )
      ))}
    </>
  );
};
